<template>
    <a-modal
        v-model="showSelectWindow"
        :title="title"
        :centered="true"
        :closable="true"
        :destroyOnClose="true"
        :maskClosable="false"
        :keyboard="false"
        :width="width"
        :afterClose="handleAfterSelect"
    >
        <div class="dataselect-main" :style="{ height: height + 'px' }">
            <FGDataSelectQuery ref="queryPanel" :queryFields="queryFields" @query="handleQuery" v-if="queryFields.length > 0" />
            <div class="dataselect-table-container" :style="{ top: (queryFields.length > 0 ? 60 : 0) + 'px' }">
                <template v-if="this.selectInfo.select_type === 1">
                    <a-spin :spinning="masterLoading">
                        <vxe-table
                            ref="masterTable"
                            size="mini"
                            auto-resize
                            :height="height - (queryFields.length > 0 ? 60 : 0) - (masterPageSize > 0 ? 44 : 0)"
                            row-id="ID"
                            highlight-hover-row
                            highlight-current-row
                            show-overflow="tooltip"
                            :data="masterData"
                            :sort-config="{
                                trigger: 'cell',
                                defaultSort: { field: masterSortField, order: masterSortOrder },
                                remote: true,
                                orders: ['ASC', 'DESC']
                            }"
                            :checkbox-config="{
                                trigger: 'row',
                                showHeader: false
                            }"
                            @sort-change="handleMasterSortChange"
                            @checkbox-change="handleCheckboxChange"
                            @cell-dblclick="handleDblClick"
                        >
                            <vxe-table-column type="checkbox" width="60" align="center"></vxe-table-column>
                            <vxe-table-column type="seq" title="序号" width="80" align="center" header-align="center"></vxe-table-column>
                            <vxe-table-column
                                v-for="(field, index) in masterFields"
                                :key="index"
                                :field="field.name"
                                :title="field.label"
                                :width="field.width"
                                :align="field.dictNo ? 'center' : field.type === 'DATE' || field.type === 'NUMBER' ? 'right' : 'left'"
                                header-align="center"
                                sortable
                            >
                                <template v-slot="{ row }">
                                    <template v-if="field.dictNo">
                                        <FGDictRenderer :dictNo="field.dictNo" v-model="row[field.name]" />
                                    </template>
                                    <template v-else-if="field.type === 'DATE'">
                                        {{ $FG_util.formatDate(row[field.name], field.format) }}
                                    </template>
                                    <template v-else-if="field.type === 'NUMBER'">
                                        {{ $FG_util.formatNumber(row[field.name], field.format) }}
                                    </template>
                                    <template v-else>
                                        {{ row[field.name] }}
                                    </template>
                                </template>
                            </vxe-table-column>
                        </vxe-table>
                        <vxe-pager
                            background
                            size="mini"
                            style="margin-top:5px"
                            :current-page.sync="masterPageNo"
                            :page-size="masterPageSize"
                            :total="masterTotal"
                            :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total']"
                            @page-change="handleMasterPageChange"
                            v-if="masterPageSize > 0"
                        >
                        </vxe-pager>
                    </a-spin>
                </template>
            </div>
        </div>
        <template v-slot:footer>
            <div class="dataselect-footer">
                <span class="selected-info">
                    已选择
                    <span class="selected-info-count">{{ selectedData.length }}</span>
                    条数据
                </span>

                <span style="flex:1"></span>
                <a-button @click="handleCancel" style="margin-right:8px;">
                    取消
                </a-button>
                <a-button type="primary" @click="handleOk">
                    确定
                </a-button>
            </div>
        </template>
    </a-modal>
</template>
<script>
import FGDataSelectQuery from "./FGDataSelectQuery";
import FGDataSelectMixin from "./FGDataSelectMixin";

const max_width = document.body.clientWidth;
const max_height = document.body.clientHeight;
export default {
    name: "FGDataSelect",
    mixins: [FGDataSelectMixin],
    components: {
        FGDataSelectQuery
    },
    data() {
        return {
            // 已选择数据
            selectedData: [],
            // 是否显示选择窗口
            showSelectWindow: false,

            // 查询条件值
            queryCondition: "",
            queryFieldValues: [],

            masterData: [],
            masterLoading: false,

            detailData: [],
            detailLoading: false
        };
    },
    computed: {
        title() {
            return `[${this.selectInfo.select_no}]${this.selectInfo.select_name}`;
        },
        width() {
            return this.selectInfo.window_width <= 0 || this.selectInfo.window_width > max_width - 50 ? max_width - 50 : this.selectInfo.window_width;
        },
        height() {
            return this.selectInfo.window_height - 108 <= 0 || this.selectInfo.window_height > max_height - 50
                ? max_height - 50 - 108
                : this.selectInfo.window_height - 108;
        }
    },
    watch: {
        isShow: {
            handler(newVal) {
                if (newVal) {
                    // 清空已选择数据
                    this.selectedData = [];
                    // 清空查询条件
                    this.queryCondition = "";
                    // 重置查询面板
                    if (this.$refs.queryPanel) this.$refs.queryPanel.handleReset();
                    // 快速查询，即如果只有一条数据匹配则不弹出选取窗口直接选中数据
                    if (
                        this.quickSelectOptions &&
                        this.quickSelectOptions.enable &&
                        this.quickSelectOptions.name &&
                        this.notEmpty(this.quickSelectOptions.value)
                    ) {
                        let sql = this.selectInfo.master_sql;
                        sql += " WHERE 1=1 ";
                        sql += this.condition || "";
                        sql += this.createQueryCondition([this.quickSelectOptions]);
                        this.$FG_http
                            .post(
                                "./api/jsaec/register/loadData",
                                {
                                    sql: this.$FG_util.encodeURL(sql),
                                    pageSize: 2,
                                    pageNo: 1,
                                    selectNo: this.selectInfo.select_no,
                                    queryFields: this.queryFieldValues,
                                    sort: {
                                        field: this.masterSortField,
                                        order: this.masterSortOrder
                                    },
                                    ...this.varOptions
                                },
                                {
                                    showError: true,
                                    showSuccess: false
                                }
                            )
                            .then(({ success, data, errMsg }) => {
                                if (success && data && data.data && data.data.length === 1) {
                                    this.$emit("saveselect", data.data);
                                    this.handleAfterSelect();
                                } else {
                                    // 初始化已选择数据
                                    this.initSelectedData().then(() => {
                                        this.doMasterQuery();
                                        this.showSelectWindow = true;
                                    });
                                }
                            });
                    } else {
                        // 初始化已选择数据
                        this.initSelectedData().then(() => {
                            this.doMasterQuery();
                            this.showSelectWindow = true;
                        });
                    }
                }
            }
        }
    },
    methods: {
        initSelectedData() {
            let initData = (this.initData || []).filter((item) => item);
            if (initData.length > 0) {
                let sql = this.selectInfo.master_sql;
                sql += " WHERE 1=1 ";
                sql += this.condition || "";
                sql += " AND ID IN ('" + initData.join("','") + "')";
                return this.$FG_http
                    .post(
                        "./api/jsaec/register/loadData",
                        {
                            sql: this.$FG_util.encodeURL(sql),
                            pageSize: this.multiSelect ? -1 : 1,
                            pageNo: 1,
                            selectNo: this.selectInfo.select_no,
                            initData,
                            queryFields: this.queryFieldValues,
                            sort: {
                                field: this.masterSortField,
                                order: this.masterSortOrder
                            },
                            ...this.varOptions
                        },
                        {
                            showError: true,
                            showSuccess: false
                        }
                    )
                    .then(({ success, data, errMsg }) => {
                        if (success && data && data.data) {
                            this.selectedData = data.data;
                            return Promise.resolve();
                        }
                        return Promise.reject();
                    });
            }
            return Promise.resolve();
        },
        doMasterQuery() {
            this.masterData = [];
            this.masterLoading = true;
            let sql = this.selectInfo.master_sql;
            sql += " WHERE 1=1 ";
            sql += this.condition || "";
            sql += this.queryCondition || "";
            this.$FG_http
                .post(
                    "./api/jsaec/register/loadData",
                    {
                        sql: this.$FG_util.encodeURL(sql),
                        pageSize: this.masterPageSize,
                        pageNo: this.masterPageNo,
                        selectNo: this.selectInfo.select_no,
                        queryFields: this.queryFieldValues,
                        sort: {
                            field: this.masterSortField,
                            order: this.masterSortOrder
                        },
                        ...this.varOptions
                    },
                    {
                        showError: true,
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.masterLoading = false;
                    if (success && data) {
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.masterPageNo = data.pageinfo.pagenum;
                        this.masterTotal = data.pageinfo.maxrow;
                        this.selectedData.forEach((item) => this.masterData.push(item));
                        data.data.forEach((item) => {
                            if (!this.selectedData.find((elem) => elem.ID === item.ID)) {
                                this.masterData.push(item);
                            }
                        });
                        this.$refs.masterTable.setCheckboxRow(this.selectedData, true);
                    }
                });
        },
        handleMasterSortChange({ property, order }) {
            this.masterSortField = property;
            this.masterSortOrder = order;
            this.doMasterQuery();
        },
        handleMasterPageChange({ currentPage }) {
            this.masterPageNo = currentPage;
            this.doMasterQuery();
        },
        handleCheckboxChange({ records, reserves, indeterminates, checked, row }) {
            // 取消选中，从已选择记录中删除
            if (!checked) {
                let index = this.selectedData.findIndex((item) => row.ID === item.ID);
                if (index >= 0) {
                    this.selectedData.splice(index, 1);
                }
            } else {
                if (this.multiSelect) {
                    if (!this.selectedData.find((item) => row.ID === item.ID)) {
                        this.selectedData.push(row);
                    }
                } else {
                    this.$refs.masterTable.setAllCheckboxRow(false);
                    this.selectedData = [row];
                    this.$refs.masterTable.setCheckboxRow(row, true);
                }
            }
        },
        handleDblClick({ row }) {
            if (this.multiSelect) {
                if (!this.selectedData.find((item) => row.ID === item.ID)) {
                    this.selectedData.push(row);
                }
            } else {
                this.selectedData = [row];
            }
            this.handleOk();
        },
        handleQuery(queryFieldValues) {
            this.queryCondition = this.createQueryCondition(queryFieldValues);
            this.queryFieldValues = queryFieldValues;
            this.doMasterQuery();
        },
        handleOk() {
            this.$emit("saveselect", this.selectedData);
            this.showSelectWindow = false;
        },
        handleCancel() {
            this.showSelectWindow = false;
        },
        handleAfterSelect() {
            this.$emit("update:isShow", false);
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .ant-modal-body {
    padding: 0;
}
.dataselect-main {
    position: relative;

    .dataselect-table-container {
        position: absolute;
        z-index: 10;
        left: 0;
        width: 100%;
        padding: 0 10px;
    }
}

.dataselect-footer {
    display: flex;

    .selected-info {
        line-height: 32px;
        color: #ccc;

        .selected-info-count {
            color: #1890ff;
            margin: 0 5px;
        }
    }
}
</style>
